import { Component, HostListener } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss']
})
export class ScrollToTopComponent {
  isVisible = false;
  private readonly SCROLL_THRESHOLD = 300;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isVisible = window.scrollY > this.SCROLL_THRESHOLD;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}